import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EditNcmState } from "./type";

const initialState: EditNcmState = {
  ncm: "",
  state: "",
  iva: "",
  internal_tax_rate: "",
  interstate_tax: "",
  is_active: true,
};

const editNcmSlice = createSlice({
  name: "editNcm",
  initialState,
  reducers: {
    updateEditNcm(state, action: PayloadAction<Partial<EditNcmState>>) {
      return { ...state, ...action.payload };
    },
    resetEditNcm() {
      return initialState;
    },
  },
});

export const { updateEditNcm, resetEditNcm } = editNcmSlice.actions;
export default editNcmSlice.reducer;
